import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import { formatCurrency, formatDateTime } from "../../../utils/helpers";
import dayjs from "dayjs";

const PrintSolicitudPago = () => {
    const [facturas, setFacturas] = useState([]);
    const [contactos, setContactos] = useState([]);
    const [balance, setBalance] = useState(0);

    const getFacturas = async () => {
        const { data } = await request("cuentas-por-cobrar" + (window.location.search === '' ? '?' : window.location.search + '&') + 'limit=100000');
        
        setFacturas(data);
        setContactos([...(new Set(data.map(item => item.cliente.nombre)))]);

        setTimeout(() => {
            // window.print();
        }, 1500);
    };

    useEffect(() => {
        getFacturas();
    }, []);

    useEffect(() => {
        setBalance(facturas.reduce((preview, factura) => preview + factura.por_cobrar, 0));
    }, [facturas]);

    const user = auth.getUser();
    const sucursal = user.sucursales.filter(
        (suc) => suc.id === user.sucursalActual
    )[0];

    return <>
        <div className="row">
            <h2 className="col-md-12 text-center m-b-5">
            {sucursal.nombre}
            </h2>
            <div className="col-md-12 text-center uppercase"><strong>Solicitud de pago</strong></div>
            <div className="col-md-12 text-center">
                {sucursal.direccion} •{" "}
                {new Date().toLocaleString()}
            </div>
           
            <div className="col-md-12 text-right p-b-10" style={{fontSize: 'larger'}}>
                <div className="float-left">
                    TOTAL CUENTAS POR PAGAR: {facturas.length}
                </div>

                <div className="float-right">
                    <strong>BALANCE TOTAL: {formatCurrency(balance)}</strong>
                </div>
            </div>
        </div>

        {contactos.map((contacto) => <ClientTable contacto={contacto} facturas={facturas.filter((factura) => factura.cliente.nombre === contacto)} />)}
    </>;
};

const ClientTable = ({ facturas, contacto }) => {
    const [balance, setBalance] = useState(0);

    useEffect(() => {
        setBalance(facturas.reduce((preview, factura) => preview + factura.por_cobrar, 0));
    }, [facturas]);

    return <>
        <h3 className="mt-3">{contacto}</h3>

        <table className="table" style={{fontSize: 'larger'}}>
            <thead>
                <tr>
                    <th>NCF/Numero</th>
                    <th>Tipo</th>
                    <th>Cliente</th>
                    <th>Vendedor</th>
                    <th>Creación</th>
                    <th className="text-right">Vencimiento</th>
                    <th className="text-right">Monto</th>
                    <th className="text-right">Balance</th>
                </tr>
            </thead>

            <tbody>
                {facturas.map((factura) => <tr>
                    <td>{factura.numero_comprobante}</td>
                    <td className="text-capitalize">
                        {factura.tipo}
                    </td>
                    <td>
                        {factura.cliente
                            ? factura.cliente.nombre
                            : ""}
                    </td>
                    <td>
                        {factura.vendedor
                            ? `${factura.vendedor.nombre} ${factura.vendedor.apellido}`
                            : ""}
                    </td>
                    <td>
                        {!!factura.recurrencia_id
                            ? dayjs(factura.fecha).format(
                                    "DD/MM/YYYY"
                                )
                            : formatDateTime(
                                    factura.created_at
                                )}{" "}
                        <span>
                            <div>
                                {!!factura.recurrencia_id
                                    ? dayjs()
                                            .startOf("day")
                                            .diff(
                                                dayjs(
                                                    factura.fecha
                                                ).startOf(
                                                    "day"
                                                ),
                                                "day"
                                            )
                                    : dayjs()
                                            .startOf("day")
                                            .diff(
                                                dayjs(
                                                    factura.created_at
                                                ).startOf(
                                                    "day"
                                                ),
                                                "day"
                                            )}{" "}
                                días transcurridos
                            </div>
                        </span>
                    </td>
                    <td className="text-right">
                        {dayjs(
                            factura.fecha_vencimiento
                        ).format("DD/MM/YYYY")}{" "}
                        <div>{factura.plazo?.dias} Días</div>
                    </td>
                    <td className="text-right">
                        {formatCurrency(factura.total)}
                    </td>
                    <td className="text-right">
                        {formatCurrency(factura.por_cobrar)}
                    </td>
                </tr>)}
            </tbody>
        </table>

        <div className="col-md-12 text-right p-b-10 mb-5" style={{fontSize: 'larger'}}>
            <div className="float-left">
                TOTAL CUENTAS POR PAGAR: {facturas.length}
            </div>

            <div className="float-right">
                <strong>BALANCE TOTAL: {formatCurrency(balance)}</strong> 
            </div>
        </div>
    </>
};

export default PrintSolicitudPago;